import * as z from 'zod/mini';
import { GlobalOptionsSchema } from './global';

export const MyEnvironmentOptions = z.object({
  ...GlobalOptionsSchema,
  email: z.optional(z.string()),
  contactEmail: z.optional(z.string()),
});
